<template>
  <ContentWrapper
    :create-icon="can('CREATE_HOLIDAYS') ? 'add-holiday' : null"
    :header-tag="headerTag"
    search-input-id="admin-holiday-search-phrase"
    :show-back="showBack"
    title="Holidays"
    @create="handleCreate"
    @search="handleSearch"
  >
    <HolidaysTable
      class="admin-table"
      :holidays="filteredHolidays"
      :selected-id="holiday.id"
      @select="handleSelect"
    />

    <section class="admin-form-wrapper">
      <content-header
        class="admin-form-header"
        tag="h2"
        :title="holiday.id ? `Edit - ${holiday.name}` : 'Create Holiday'"
      />

      <span class="admin-form-tab">
        <img alt="Holidays" src="../../../assets/icons/holiday.svg" />
      </span>

      <HolidaysForm
        class="admin-form"
        :disabled="holiday.date === undefined"
        :holiday="holiday"
        @cancel="handleCancel"
        @delete="handleDelete"
        @save="handleSave"
      />
    </section>
  </ContentWrapper>
</template>

<script>
import ContentWrapper from "./ContentWrapper";
import HolidaysTable from "../../../components/admin/HolidaysTable";
import HolidaysForm from "../../../components/admin/HolidaysForm";

import { getHolidays } from "../../../api/HolidayAPI";

export default {
  data() {
    return {
      holiday: {},
      _holidays: [],
      search: "",
    };
  },

  props: {
    holidays: {
      type: Array,
      default: undefined,
    },
    headerTag: {
      type: String,
      default: undefined,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
    routeParams: {
      type: Object,
      default: undefined,
    },
    showBack: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    filteredHolidays() {
      const regex = this.getFilterRegex(this.search);

      return this.$data._holidays.filter((c) =>
        regex.test(
          [c?.date ?? "", c?.name ?? "", c?.description ?? ""].join(
            String.fromCharCode(0x1f)
          )
        )
      );
    },
  },

  methods: {
    handleCancel() {
      if (this.confirmIfDirty()) {
        this.holiday = {};
      }
    },
    handleCreate() {
      if (this.confirmIfDirty()) {
        this.holiday = {
          date: "",
          name: "",
          description: "",
        };
      }
    },
    handleDelete(holiday) {
      this.$data._holidays = this.$data._holidays.filter(
        (c) => c?.id !== holiday?.id
      );

      this.holiday = {};
    },
    handleSave(holiday) {
      const created = !this.holiday.id;

      this.$data._holidays = [
        ...this.$data._holidays.filter((c) => c?.id !== holiday?.id),
        holiday,
      ];

      this.handleSelect(created ? holiday : undefined, true);

      this.showAlert(
        `Your holiday has been ${created ? "created" : "updated"} successfully!`
      );
    },
    handleSearch(phrase) {
      this.search = phrase;
    },
    handleSelect(holiday, force = false) {
      if (force || this.confirmIfDirty()) {
        this.holiday = {
          ...this.$data._holidays.find((c) => c?.id === holiday?.id),
        };
      }
    },
  },

  watch: {
    "holiday.id"(to, from) {
      to === this.id ||
        this.$nextTick(() => {
          this.$router.push({
            ...this.$route,
            params: { ...this.$route.params, ...this.routeParams, id: to },
          });
        });
    },
    async holidays(to, from) {
      to === this.$data._holidays ||
        (this.$data._holidays = to?.slice?.() ?? (await getHolidays()));
    },
    "$data._holidays"(to, from) {
      if (to !== from) {
        this.$data._holidays = to;
        this.$emit("update:holidays", this.$data._holidays);
      }
    },
  },

  async created() {
    this.$data._holidays = this.holidays?.slice?.() ?? (await getHolidays());

    this.handleSelect(this);
  },

  beforeRouteUpdate(to, from, next) {
    if (!(this?.confirmIfDirty?.() ?? true)) {
      return next(false);
    }

    this.abortRequests();
    next();
  },

  beforeRouteLeave(to, from, next) {
    if (!to.params.skipDirtyCheck && !(this?.confirmIfDirty?.() ?? true)) {
      next(false);
    }

    this.abortRequests();
    next();
  },

  components: {
    ContentWrapper,
    HolidaysTable,
    HolidaysForm,
  },
};
</script>